export function BookingDiarySimplifiedCtrl(
  $scope,
  $state,
  $translate,
  workshopAPI
) {
  $scope.loading = true;

  $scope.tableSettings = {
    columns: [
      {
        field : 'event_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE'),
        },
        pipe: 'globalDate'
      },
      {
        field : 'customer_display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER'),
        },
      },
      {
        field : 'customer_mobile',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.MOBILE'),
        },
        pipe  : 'mobilePhone',
      },
      {
        field : 'make',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MAKE'),
        },
      },
      {
        field : 'model',
        header: {
          text: $translate.instant('VEHICLE_SPACE.MODEL'),
        },
      },
      {
        field : 'item_description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
        },
      },
      {
        field : 'estimated_hours',
        header: {
          text: $translate.instant('VEHICLE_SPACE.HOURS'),
        },
        width : '75',
      },
      {
        field : 'job_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS'),
        },
        pipe  : 'jobStatusBooking',
      },
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_JOBS_FOUND'),
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [5, 10, 25, 50],
      queryCount: () =>
        workshopAPI.get(
          '/event_times/bookings_list_for_day_count',
          $scope.calendar.defaultDate
        ),
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'event_date',
    },
  };

  $scope.rowSelected = function (event) {
    $state.go('app.event', {
      customer_id: event.row.customer_id,
      id         : event.row.event_id,
      vehicle_id : event.row.vehicle_id,
    });
  };

  $scope.getJobs = (params) => {
    return workshopAPI
      .get('/event_times/bookings_list_for_day', [
        $scope.calendar.defaultDate,
        params.pageSize,
        params.offset,
        params.field,
        params.direction,
      ]).then(jobs => {
        $scope.jobs = jobs;

        return jobs;
      });
  };

  $scope.init = () => {
    $scope.getJobs({
      direction: 'asc',
      field    : 'event_date',
      offset   : '0',
      pageSize : '5',
    })
    .then(jobs => {
      $scope.jobs = jobs;
      $scope.loading = false;
    });
  };

  $scope.init();
}
